import { css, styled } from 'styled-components';

const ButtonGroupButton = styled.button<{ active: boolean }>`
  padding: 4px 6px;
  border-radius: 6px;

  ${({ active, theme }) => css`
    font-size: 16px;
    font-weight: ${theme.fontWeights.regular};
    color: ${theme.colorsV2.gray60};

    &:hover {
      background: ${theme.colorsV2.gray20};
    }
    ${active &&
    css`
      background: ${theme.colorsV2.gray20};
    `}
  `}
`;

type ButtonGroupProps = {
  readonly active: number;
  readonly buttons: number[] | string[];
  readonly category: string;
};

export const ButtonGroup = ({ active, buttons }: ButtonGroupProps) => {
  return (
    <>
      {buttons.map((buttonLabel, index) => (
        <ButtonGroupButton
          active={active === index}
          // We no longer manually rate users, so we disable this input
          // but still show it to display the automatic rating.
          disabled
          key={`button-group-${buttonLabel}`}
          name={buttonLabel}
          type="button"
        >
          {buttonLabel}
        </ButtonGroupButton>
      ))}
    </>
  );
};
